import { render, staticRenderFns } from "./SlideSwipe.vue?vue&type=template&id=38af3063&scoped=true&"
import script from "./SlideSwipe.vue?vue&type=script&lang=ts&"
export * from "./SlideSwipe.vue?vue&type=script&lang=ts&"
import style0 from "./SlideSwipe.vue?vue&type=style&index=0&id=38af3063&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af3063",
  null
  
)

export default component.exports